import Text from "../../../components/ui/Text";
import xIcon from "../assets/images/x.webp";

interface Props {
  className?: string;
  titleWords: { word: string; isHighlighted?: boolean }[];
  description: string;
  onClose?: () => void;
}

const GasStationHeading = ({
  className = "",
  titleWords = [],
  description = "",
  onClose = () => {},
}: Props) => {
  return (
    <div
      className={`border-[1px] border-white/15 p-6 px-8 rounded-md flex items-center justify-between space-x-2 ${className}`}
    >
      {/** Title */}
      <div className="flex items-center space-x-3">
        <div className="flex gap-1 flex-wrap items-center">
          {titleWords?.map(({ word, isHighlighted }, i) => (
            <Text
              size="2xl"
              key={i}
              style={{
                textShadow: isHighlighted
                  ? "-8px -5px 8px  rgba(86, 245, 255, 0.3)"
                  : "auto",
              }}
              className={` relative bebas-neue-font ${
                isHighlighted
                  ? "text-[#56F5FF] mt-[-2.5px] !font-[400] "
                  : "text-white !font-[500] "
              }`}
            >
              {word}
            </Text>
          ))}
        </div>

        <Text
          size="xs"
          className="text-white/50 max-w-[165px] leading-4 gilroy-font"
        >
          {description}
        </Text>
      </div>

      {/** Close */}
      <button
        title="Close"
        onClick={onClose}
        className="border-[#FF4141] border-[1px] rounded-md  bg-gradient-to-b from-[#FF4141]/20 via-[#FF4141]/30 to-[#FF4141]/35 p-3 transition hover:opacity-70 active:scale-95"
      >
        <img alt="X" src={xIcon} className="w-[14px] h-[14px]" />
      </button>
    </div>
  );
};

export default GasStationHeading;
